import { render, staticRenderFns } from "./closure.vue?vue&type=template&id=061066f0&scoped=true"
import script from "./closure.vue?vue&type=script&lang=js"
export * from "./closure.vue?vue&type=script&lang=js"
import style0 from "./closure.vue?vue&type=style&index=0&id=061066f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061066f0",
  null
  
)

export default component.exports